// Module
var code = "<div class=\"deployment-plan\"> <div class=\"tbl\"> <div class=\"headerLine\"> <div class=\"cell tbl-name\"> <span>Flow</span> </div> <div class=\"cell tbl-dg\"> <span>Deployment Group</span> </div> <div class=\"cell tbl-nodes\"> <span>Nodes</span> </div> </div> </div> <div class=\"deployment-plan-list\"> </div> </div>";
// Exports
export default code;